import React, {FunctionComponent} from "react";
import Button, {ButtonProps, ButtonSize, ButtonStyle} from "../../snippet/button/Button";
import {TranslationLibFile} from "../../../utils/locale";
import {useTranslation} from "react-i18next";
import {Action} from "../../../utils/Action";

type ButtonAddProps = Omit<ButtonProps, "children" | "icon" | "reverse">;

const ButtonAdd: FunctionComponent<ButtonAddProps> = ({size, style, ...rest}) => {
    const {t} = useTranslation(TranslationLibFile.COMMON);

    return (
        <Button
            size={size || ButtonSize.SMALL}
            style={style || ButtonStyle.PRIMARY_GREEN}
            icon={{name: "add_circle"}}
            {...rest}
        >
            {t(Action.ADD.labelKey)}
        </Button>
    );
};

export default ButtonAdd;
